/* eslint-disable no-unused-vars */
export const enum PaymentStatus{
    Created = 'created',
    Paid = 'paid',
    Canceled = 'canceled',
}